/**
 * Nutrition foods queries for Zero 0.25+.
 *
 * @see https://zero.rocicorp.dev/docs/queries
 */

import { defineQuery } from "@rocicorp/zero";
import { z } from "zod";

import { zql } from "../schema";

/**
 * Query to list all foods with optional filters.
 */
export const allFoods = defineQuery(
  z.object({
    search: z.string().optional(),
    foodGroup: z.string().optional(),
    limit: z.number().default(100),
  }),
  ({ args: { search, foodGroup, limit } }) => {
    let query = zql.habit_nutrition_food.limit(limit);

    if (search) {
      query = query.where("name", "ILIKE", `%${search}%`);
    }

    if (foodGroup) {
      query = query.where("foodGroup", "=", foodGroup);
    }

    return query;
  }
);

/**
 * Query to get a single food by ID.
 */
export const foodById = defineQuery(
  z.object({
    id: z.string(),
  }),
  ({ args: { id } }) => zql.habit_nutrition_food.where("id", "=", id).one()
);
